import { IMessageFile } from '../components/forum-message';
import { IPagedQuery, IPagedQueryS } from '../components/paginate';

export interface IHelpDeskState {
    // redirect: boolean;
    // redirectUrl: string;
    filters: IFilterHelpdesk;
    isSelected:boolean;
    endCreatedDate: Date|string;
    subject?:string;
    isSearched:boolean;
    description:string;
    filterInitialValues: any;
    isHelpModalOpen: boolean;
    ishelpDeskChatModalOpen: boolean;
    updateQuestionId?: string;
    resultHtml?: any;
    conversationContainer?:any;
    isPreviewModalOpen?: boolean;
    categories: Array<any>;
    status?:Array<any>;
    assignedUser?:Array<any>;
    selectedHelpDeskItem?:any;
    selectedHelpDeskMessageId?:string;
    selectedHelpDeskId?:string;
    selectedHelpDeskRefId?:string;
    helpDeskMessage?:string;
    selectedHelpDeskChatItem?:any;
    helpDeskList?: Array<IHelpdeskListItem>;
    helpDeskChat?:Array<IHelpDeskChatItem>;
    textAreaValue?:any;
    messageTextAreaValue?:any;
    getQuillToolbarModule:any;
    fileId?: any;
    showEmojiPicker?: boolean;
    showFileUploader?: boolean;
    showFileUploaderCount?: number;
    fileUploaded?: boolean;
    fileUploadKey?: any;
    isLoadingProcess?:boolean;
}


export interface IHelpDeskProps {
    dispatch?: any;
    categories?: Array<any>;
    assignedUser?: Array<any>;
    status?:Array<any>;
    subject?:string;
    helpDeskList?: Array<IHelpdeskListItem>;
    helpDeskListPage?:number;
    helpDeskListTake?:number;
    helpDeskListTotalCount?:number;
    helpDeskChat?:Array<any>;
    lastMessageDate?:string;
    message?:string;
    isDefaultUpdateHelpDesk?: number;
    filters?: IFilterHelpdesk;
    triggerMessageModal?: any;
    fileInputKey?: string;
    replyUser?:string;
    currentUserName?:string;
    identity?: any;
    moduleItems?:any;
    isSimulate?:boolean;  
}

export interface IHelpDeskListProps {
  categories:Array<any> | null,
  status:Array<any> | null
}
export interface IHelpDeskChatItem {

    helpDeskId: string,
    senderUser: string | null;
    replyUser: string,
    senderUserName: string,
    replyUserName: string | null;
    message: string,
    isOwnerMessage :string,
    createdDate: string,
    lastMessageDate: string | null;
    messageFiles: Array<IMessageFile>,
    fileId: null,
    mesageFile: IMessageFile | null;
    forumMessageId:string,


    createdUser: any;
    id: number | null;
    assignedUser: string | null;
    senderName: string | null;
    userType:number;
    helpTitle:string | null;



    //replyUser:string | null;
}
export interface IHelpdeskListItem {
    helpDeskId: string,
    helpDeskIdRef:string,
    senderUser:string,
    replyUser: string,
    senderUserName: string,
    replyUserName: string,
    message: string,
    createdDate: string,
    lastMessageDate: string,
    messageFiles: null,
    fileId: null,
    mesageFile: null,
    helpDeskStatusText:string,

    createdUser:string;
    subject:string;
    lastMessage: string | null;
    lastReplyTime: string | null;
    status: string | null;
    assignedUser:string | null;
    helpTitle:string | null;

}

export interface IHelpdeskFilter {
    id: number | null;
    message: string | null;
    createdDate: string | null;
    lastReplyTime: string | null;
    status: string | null;
    subject:string | null;
    //replyUser:string | null;
}

export const HelpDeskSearchInitialValues: IFilterHelpdesk = {
    orderBy: '',
    query: null,
    page: 1,
    total: -1,
    skip: 0,
    take: 10
};
export interface IFilterHelpdesk extends IPagedQuery {
    take: number;
    page: number;
    total: number;
    skip: number;
    orderBy: string | undefined;
}
